import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, GridUpdateMessage } from 'libs/ui';
import RoleForm from './forms/role-form';
import { PermissionsForm } from './forms/permissions-form';
import { getTableParams } from './grid.params';

export const RoleGrid = (props) => {
  const { count, entries, className, theme, updateEntry } = props;
  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});

  const { t } = useTranslation();

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  const permissionsAction = (row) => {
    setRow(row);
    setShowForm('permissionsForm');
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('roles.update');
  const rightAdd = user.haveRight('roles.add');
  const actions = [];

  if (rightEdit) {
    actions.push({
      title: 'Переименовать',
      action: editItemAction,
    });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }

  const initial = showForm === 'addForm' ? {} : { ...row };
  const tableParams = useMemo(() => getTableParams(t), []);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Роли')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={rightEdit ? permissionsAction : undefined}
        {...tableParams}
        updateEntry={updateEntry}
      />

      {(showForm === 'addForm' || showForm === 'editForm') && <RoleForm type={showForm} close={() => setShowForm('')} setMessage={setMessage} refresh={props.refresh} initialValues={initial} />}
      {showForm === 'permissionsForm' && <PermissionsForm close={() => setShowForm('')} id={row.id} setMessage={setMessage} refresh={props.refresh} initialValues={row} />}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
